import React from 'react';

export const TopResultsCarousel = ({
  header,
  slides,
}: {
  header: string;
  slides: {
    id: string;
    slide: React.ReactNode;
  }[];
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h3 className="font-title text-title-l font-medium">{header}</h3>
      </div>
      <div className="mb-3 flex grid-cols-2 flex-col gap-3 md:mb-0 md:grid md:grid-cols-4 md:gap-5">
        {slides.map(({ slide }) => slide)}
      </div>
    </div>
  );
};
